<div>
  @if (form) {
    <form [formGroup]="form">
      @for (field of formFields$ | async; track field) {
        <div class="form-row">
          <emm-dynamic-management-form-field
            [formField]="field" [form]="form" [itemTag]="itemTag"
            [selectedSubmenu]="selectedSubmenu"
            [selectedLocation]="selectedLocation"
            [nodeId]="nodeId" [itemTagPath]="this.itemTagPath"
            [effectiveDate]="effectiveDate"
          ></emm-dynamic-management-form-field>
        </div>
      }
    </form>
  }
</div>
